import React, { useState } from "react";
import PublishForm from "./PublishForm.js";
import EmbedFormSettingsNew from "./EmbedFormSettings/EmbedFormSettingsNew.js";
import FormBuilderElements from "../NewFormBuilder/FormBuilderTools/FormBuilderElements.js";

const OptionsContainer = ({
  mode,
  formWidth,
  setFormWidth,
  formBackgroundColor,
  setFormBackgroundColor,
  formLanguage,
  setFormLanguage,
  settitleDropDown,
  setDropDownLanguage,
  emailToReceiveFiles, //Settings
  setEmailToReceiveFiles,
  uploadFilesLimit,
  setUploadFilesLimit,
  fileSizeLimit,
  setFileSizeLimit,
  manuallyDeleteCheckbox,
  setManuallyDeleteCheckbox,
  automaticallyDeleteCheckbox,
  setAutomaticallyDeleteCheckbox,
  daysToDelete,
  setDaysToDelete,
  uploadAnyFormatsCheckbox,
  setUploadAnyFormatsCheckbox,
  allowFolowingFormatsCheckbox,
  setAllowFolowingFormatsCheckbox,
  denyForamtsCheckbox,
  setDenyForamtsCheckbox,
  fileFormats,
  setFileFormats,
  potentialCustomers,
  setPotentialCustomers,
  customersFilesDownloaded,
  setCustomersFilesDownloaded,
  orderConfirmation,
  setOrderConfirmation,
  sendEmailToRecipients,
  setSendEmailToRecipients,
  displayLink,
  setDisplayLink,
  displaySendAnotherEmail,
  setDisplaySendAnotherEmail,
  thankyouPageRedirect,
  setThankyouPageRedirect,
  redirectLink,
  setRedirectLink,
  protectFormWithPassword,
  setProtectFormWithPassword,
  passwordForm,
  setPasswordForm,
  setInvalidFilesFormat,
  invalidFilesFormat,
  setInvalidAlert,
  invalidAlert,
  invalidEmailReceiveFiles,
  setInvalidEmailReceiveFiles,
  setUpdateBeforeSave,
  EmbedDynamicId,
  formHeight,
  websiteURL,
  setWebsiteURL,
  invalidURL,
  setInvalidURL,
  userEmbedPage,
  setUserEmbedPage,
  embedDynamicPageId,
  setEmbedDynamicPageId,
  notExistEmbedPage,
  setNotExistEmbedPage,
  setDisplayOnEmbedPage,
  displayOnEmbedPage,
  displaySelectIntegrateTooltip,
  setDisplaySelectIntegrateTooltip,
  addNewField,
  formItems,
  setFormItems,
  addItemsToCart,
  setDirectionForm,
  allowAccess,
  setAllowAccess,
  emptyPassword,
  setEmptyPassword,
  emptyOrInvalidUrl,
  setEmptyOrInvalidUrl,
  displayToSubUsers,
  setDisplayToSubUsers,
  formMaxHeight,
  setFormMaxHeight,
  deleteMailLink,
  setDeleteMailLink,
  setHideSavedText,
  viewMode,
  setViewMode,
  displayTypeSubUsers,
  setDisplayTypeSubUsers,
  listDomains,
  setListDomains,
  isCheckedPreventDisplayForm,
  setIsCheckedPreventDisplayForm,
  emptyDomainsError,
  setEmptyDomainsError,
}) => {
  const renderOption = () => {
    switch (mode) {
      case "form":
        return (
          <FormBuilderElements
            addItemsToCart={addItemsToCart}
            addNewField={addNewField}
            formItems={formItems}
          />
        );
      case "publish":
        return (
          <PublishForm
            displaySelectIntegrateTooltip={displaySelectIntegrateTooltip}
            setDisplaySelectIntegrateTooltip={setDisplaySelectIntegrateTooltip}
            EmbedDynamicId={EmbedDynamicId}
            formWidth={formWidth}
            formHeight={formHeight}
            websiteURL={websiteURL}
            setWebsiteURL={setWebsiteURL}
            invalidURL={invalidURL}
            setInvalidURL={setInvalidURL}
            setUpdateBeforeSave={setUpdateBeforeSave}
            userEmbedPage={userEmbedPage}
            setUserEmbedPage={setUserEmbedPage}
            embedDynamicPageId={embedDynamicPageId}
            setEmbedDynamicPageId={setEmbedDynamicPageId}
            notExistEmbedPage={notExistEmbedPage}
            setNotExistEmbedPage={setNotExistEmbedPage}
            setDisplayOnEmbedPage={setDisplayOnEmbedPage}
            displayOnEmbedPage={displayOnEmbedPage}
            formMaxHeight={formMaxHeight}
            setHideSavedText={setHideSavedText}
          />
        );
      case "settings":
        return (
          <EmbedFormSettingsNew
            formLanguage={formLanguage}
            setFormLanguage={setFormLanguage}
            settitleDropDown={settitleDropDown}
            setDropDownLanguage={setDropDownLanguage}
            emailToReceiveFiles={emailToReceiveFiles} //Settings
            setEmailToReceiveFiles={setEmailToReceiveFiles}
            uploadFilesLimit={uploadFilesLimit}
            setUploadFilesLimit={setUploadFilesLimit}
            fileSizeLimit={fileSizeLimit}
            setFileSizeLimit={setFileSizeLimit}
            manuallyDeleteCheckbox={manuallyDeleteCheckbox}
            setManuallyDeleteCheckbox={setManuallyDeleteCheckbox}
            automaticallyDeleteCheckbox={automaticallyDeleteCheckbox}
            setAutomaticallyDeleteCheckbox={setAutomaticallyDeleteCheckbox}
            daysToDelete={daysToDelete}
            setDaysToDelete={setDaysToDelete}
            uploadAnyFormatsCheckbox={uploadAnyFormatsCheckbox}
            setUploadAnyFormatsCheckbox={setUploadAnyFormatsCheckbox}
            allowFolowingFormatsCheckbox={allowFolowingFormatsCheckbox}
            setAllowFolowingFormatsCheckbox={setAllowFolowingFormatsCheckbox}
            denyForamtsCheckbox={denyForamtsCheckbox}
            setDenyForamtsCheckbox={setDenyForamtsCheckbox}
            fileFormats={fileFormats}
            setFileFormats={setFileFormats}
            potentialCustomers={potentialCustomers}
            setPotentialCustomers={setPotentialCustomers}
            customersFilesDownloaded={customersFilesDownloaded}
            setCustomersFilesDownloaded={setCustomersFilesDownloaded}
            orderConfirmation={orderConfirmation}
            setOrderConfirmation={setOrderConfirmation}
            sendEmailToRecipients={sendEmailToRecipients}
            setSendEmailToRecipients={setSendEmailToRecipients}
            displayLink={displayLink}
            setDisplayLink={setDisplayLink}
            displaySendAnotherEmail={displaySendAnotherEmail}
            setDisplaySendAnotherEmail={setDisplaySendAnotherEmail}
            thankyouPageRedirect={thankyouPageRedirect}
            setThankyouPageRedirect={setThankyouPageRedirect}
            redirectLink={redirectLink}
            setRedirectLink={setRedirectLink}
            protectFormWithPassword={protectFormWithPassword}
            setProtectFormWithPassword={setProtectFormWithPassword}
            passwordForm={passwordForm}
            setPasswordForm={setPasswordForm}
            allowAccess={allowAccess}
            setAllowAccess={setAllowAccess}
            setInvalidFilesFormat={setInvalidFilesFormat}
            invalidFilesFormat={invalidFilesFormat}
            setInvalidAlert={setInvalidAlert}
            invalidAlert={invalidAlert}
            invalidEmailReceiveFiles={invalidEmailReceiveFiles}
            setInvalidEmailReceiveFiles={setInvalidEmailReceiveFiles}
            setUpdateBeforeSave={setUpdateBeforeSave}
            formWidth={formWidth}
            setFormWidth={setFormWidth}
            formBackgroundColor={formBackgroundColor}
            setFormBackgroundColor={setFormBackgroundColor}
            setDirectionForm={setDirectionForm}
            emptyPassword={emptyPassword}
            setEmptyPassword={setEmptyPassword}
            emptyOrInvalidUrl={emptyOrInvalidUrl}
            setEmptyOrInvalidUrl={setEmptyOrInvalidUrl}
            displayToSubUsers={displayToSubUsers}
            setDisplayToSubUsers={setDisplayToSubUsers}
            formMaxHeight={formMaxHeight}
            setFormMaxHeight={setFormMaxHeight}
            deleteMailLink={deleteMailLink}
            setDeleteMailLink={setDeleteMailLink}
            viewMode={viewMode}
            setViewMode={setViewMode}
            displayTypeSubUsers={displayTypeSubUsers}
            setDisplayTypeSubUsers={setDisplayTypeSubUsers}
            listDomains={listDomains}
            setListDomains={setListDomains}
            isCheckedPreventDisplayForm={isCheckedPreventDisplayForm}
            setIsCheckedPreventDisplayForm={setIsCheckedPreventDisplayForm}
            emptyDomainsError={emptyDomainsError}
            setEmptyDomainsError={setEmptyDomainsError}
          />
        );
      default:
        return <FormBuilderElements addNewField={addNewField} />;
    }
  };
  //get the width of the page
  const [width, setWidth] = useState(window.innerWidth);
  return (
    <div
      className={`content-options ${
        mode === "form" && width <= 1023 ? "hide-options" : ""
      }`}
    >
      <div className="options-container">{renderOption()}</div>
    </div>
  );
};

export default OptionsContainer;
